import {
  IItemTemplateTiming,
  ITaskTemplate,
  ITimelineItem
} from '@dadohr/shared/domainTypes/experience';
import styled from '@emotion/styled';
import { ExternalLink } from 'lucide-react';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { getResolvedTriggersForTimelineItem } from '../../../../../../services/experiences/template';
import { escapeReplacements } from '../../../../../../services/formatter';
import { getItemDisplayName } from '../../../../helpers/adminName';
import { tokens } from '../../newux/kit';

const TriggerLink = styled('button')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;

  svg {
    opacity: 0;
    transition: opacity 120ms ease;
  }

  &:hover {
    color: ${tokens.color.blue600};
  }
  &:hover svg {
    opacity: 1;
  }
`;

export const TriggerList: React.FC<{
  timing: IItemTemplateTiming;
  allTasks: ITaskTemplate[];
  onGoToOtherItem?: (nextItem: ITimelineItem) => void;
}> = ({ timing, allTasks, onGoToOtherItem, children }) => {
  const { t } = useUnsafeTranslation();

  const triggers = getResolvedTriggersForTimelineItem(timing, allTasks);
  return (
    <div>
      {triggers.map((trigger) => {
        if (trigger.condition !== 'COMPLETE') {
          return null;
        }
        return (
          <div key={`${trigger.itemType}-${trigger.itemId}`}>
            {`${t('When task completes')}: `}
            {onGoToOtherItem ? (
              <TriggerLink
                type="button"
                onClick={(ev) => {
                  ev.stopPropagation();
                  onGoToOtherItem({ item: trigger.item, itemType: 'TASK' });
                }}
              >
                <span style={{ fontWeight: 400 }}>
                  {escapeReplacements(getItemDisplayName(trigger.item))}
                </span>
                <ExternalLink size={16} strokeWidth={1.5} />
              </TriggerLink>
            ) : (
              <span style={{ fontWeight: 400 }}>
                {escapeReplacements(getItemDisplayName(trigger.item))}
              </span>
            )}
          </div>
        );
      })}
      {children}
    </div>
  );
};
